import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  Domanda,
  GestioneColloquiInizialiScuolaInfanzia,
  GestioneSchedaControlloPulizie,
  GestioneSchedaControlloPulizieRow, StrumentoDiRegistrazioneArchivio
} from '@gpi/lbl/shared/entity';

@Component({
  selector: 'lbl-app-ui-strumento-registrazione-gestione-scheda-controllo-pulizie',
  templateUrl: './strumento-registrazione-gestione-scheda-controllo-pulizie.component.html',
  styleUrls: ['./strumento-registrazione-gestione-scheda-controllo-pulizie.component.scss'],
})
export class StrumentoRegistrazioneGestioneSchedaControlloPulizieComponent implements OnInit, OnChanges {
  @Input()
  strumentiDiRegistrazioneArchivio: StrumentoDiRegistrazioneArchivio[] = [];
  @Output()
  updatedStrumentiDiRegistrazioneArchivio: EventEmitter<StrumentoDiRegistrazioneArchivio[]> = new EventEmitter();

  get strumentoDiRegistrazioneArchivio(): StrumentoDiRegistrazioneArchivio {
    return this.strumentiDiRegistrazioneArchivio[0];
  }

  get content(): GestioneSchedaControlloPulizie {
    let content = this.strumentoDiRegistrazioneArchivio.content as GestioneSchedaControlloPulizie;

    if (!content) {
      content = GestioneSchedaControlloPulizie.InitContent();
    }

    return content;
  }

  form: FormGroup;

  get formListaControlli(): FormArray {
    return this.form.get('listaControlli') as FormArray;
  }
  get formListaControlliControlsTable()  {
    return this.formListaControlli.controls.filter(c => c.value.descrizioneControllo);
  }
  get formListaNonConformitaControlsTable()  {
    return this.formListaControlli.controls.filter(c => !c.value.descrizioneControllo);
  }
  get listaControlliValorizzatiLength() {
    return this.formListaControlliControlsTable.filter(c => c.value.conforme != '').length;
  }

  listaControlliDisplayedColumns = ['descrizioneControllo', 'conforme', 'osservazioni'];
  listaNonConformitaDisplayedColumns = ['rif', 'provvedimento', 'dataProvvedimento'];
  listaCategorieRows = [{category: 'pavimenti_scale', index: 0}, {category: 'superfici_verticali_soffitti', index: 4}, 
    {category: 'servizi_igienici', index: 11},  {category: 'varie', index: 15}];

  ngOnInit() {
    this.form = this.buildForm();
    this.pushCategoryFormRows();

    this.form.valueChanges.subscribe(() => {
      this.updatedStrumentiDiRegistrazioneArchivio.emit(this.buildStrumentoForm());
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.strumentiDiRegistrazioneArchivio && changes.strumentiDiRegistrazioneArchivio.currentValue) {
        this.form = this.updateForm(this.content);
      }
    }
  }

  buildForm(): FormGroup {
    const form = new FormGroup({
      data: new FormControl(this.content.data),
      ora: new FormControl(this.content.ora),

      listaControlli: this.buildFormListaControlli(this.content.listaControlli),
    });
    return form;
  }

  buildFormListaControlli(listaControlli: GestioneSchedaControlloPulizieRow[]): FormArray {
    const form = new FormArray(listaControlli.map((value) => this.buildFormControllo(value))); 
    return form;
  }

  pushCategoryFormRows() {
    for (let cat of this.listaCategorieRows) {
      if(this.formListaControlli.length > cat.index){
        this.formListaControlli.insert(cat.index, this.buildFormControlloEmpty(cat.category));
      }
    }
  }

  buildFormControlloEmpty(categoria: string): FormGroup {
    const form = new FormGroup({
      conforme: new FormControl(''),
      dataProvvedimento: new FormControl(null),
      descrizioneControllo: new FormControl(categoria),
      osservazioni: new FormControl(null),
      provvedimento: new FormControl(null),
      rif: new FormControl(null),
    });

    return form;
  }

  buildFormControllo(controllo: GestioneSchedaControlloPulizieRow): FormGroup {
    const form = new FormGroup({
      conforme: new FormControl(controllo.conforme),
      dataProvvedimento: new FormControl(controllo.dataProvvedimento),
      descrizioneControllo: new FormControl(controllo.descrizioneControllo),
      osservazioni: new FormControl(controllo.osservazioni),
      provvedimento: new FormControl(controllo.provvedimento),
      rif: new FormControl(controllo.rif),
    }, { updateOn: 'blur' });

    return form;
  }

  updateForm(entity: GestioneSchedaControlloPulizie): FormGroup {
    const form = this.buildForm();
    form.patchValue(entity);

    return form;
  }

  buildStrumentoForm() {
    const form = this.form.getRawValue();
    form.listaControlli = form.listaControlli.filter(x => x.conforme != '');  //ignoro le righe di separazione
    this.strumentiDiRegistrazioneArchivio[0].content = form;
    console.log(form.listaControlli);
    return this.strumentiDiRegistrazioneArchivio;
  }

  submit(form: FormGroup) {
    if (form.valid) {
    }
  }

  isCategorySeparator = (row: number) => {
    return this.listaCategorieRows.map(cat => cat.index).includes(row);
  }
}
